"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllReviewsUrl = exports.getContactUrl = exports.getSignupUrl = exports.getLocalizedHubSpotUrl = exports.getStorefrontScreenshotUrl = exports.getAllCategoriesUrl = exports.getAllCollectionsUrl = exports.getConnectedAppsUrl = exports.getHasPathPagination = exports.getPathPagination = exports.stripPathPagination = exports.getCollectionUrl = exports.getListingDetailUrl = exports.getCategoryFilterUrl = exports.getSuperCategoryFilterUrl = exports.getFormattedUrl = exports.getLocalizedPublicUrl = exports.getLocalizedPublicPath = exports.getPublicRootUrl = exports.getLoginUrlWithRedirect = exports.getAppShortlink = exports.getAdminPreviewRootUrl = exports.getEmbedRootUrl = exports.getAppRootUrl = exports.getLoginUrl = void 0;

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _params = require("hub-http/helpers/params");

var _url = require("hub-http/helpers/url");

var CategorySlug = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/urlSlugs/CategorySlug"));

var SuperCategorySlug = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/urlSlugs/SuperCategorySlug"));

var StorefrontCollectionSlug = _interopRequireWildcard(require("../constants/StorefrontCollectionSlug"));

var _env = require("./env");

var _groupTags = require("ecosystem-marketplace-core/utils/groupTags");

var _history = require("./history");

var APP_ROOT = '/marketplace/apps';
var PUBLIC_PROXY = '/static';

var getLoginUrl = function getLoginUrl() {
  return "https://app.hubspot" + ((0, _env.isQa)() ? 'qa' : '') + ".com/login";
};

exports.getLoginUrl = getLoginUrl;

var getAppRootUrl = function getAppRootUrl() {
  return "/ecosystem/" + _PortalIdParser.default.get() + APP_ROOT;
};

exports.getAppRootUrl = getAppRootUrl;

var getEmbedRootUrl = function getEmbedRootUrl() {
  return getAppRootUrl() + "/embed";
};

exports.getEmbedRootUrl = getEmbedRootUrl;

var getAdminPreviewRootUrl = function getAdminPreviewRootUrl() {
  return '/';
};

exports.getAdminPreviewRootUrl = getAdminPreviewRootUrl;

var getLocation = function getLocation() {
  return window ? window.location : {};
};

var getAppShortlink = function getAppShortlink(pathname) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return "https://app.hubspot" + ((0, _env.isQa)() ? 'qa' : '') + ".com/l/ecosystem" + APP_ROOT + pathname + (Object.keys(params).length ? "?" + (0, _params.stringify)(params) : '');
};

exports.getAppShortlink = getAppShortlink;

var getLoginUrlWithRedirect = function getLoginUrlWithRedirect(pathname) {
  return getLoginUrl() + "/?loginRedirectUrl=" + encodeURIComponent("" + getAppShortlink(pathname));
};

exports.getLoginUrlWithRedirect = getLoginUrlWithRedirect;

var getIsPublicProxy = function getIsPublicProxy() {
  var _getLocation = getLocation(),
      pathname = _getLocation.pathname;

  return pathname && pathname.startsWith(PUBLIC_PROXY);
};

var getPublicRootUrl = function getPublicRootUrl() {
  var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
  var isPublicProxy = getIsPublicProxy();
  var path = APP_ROOT;

  switch (lang) {
    case 'pt':
    case 'pt-br':
      path = "/pt" + path;
      break;

    case 'de':
    case 'es':
    case 'fr':
    case 'ja':
      path = "/" + lang + path;
      break;

    default:
      break;
  }

  return isPublicProxy ? "" + PUBLIC_PROXY + path : path;
};

exports.getPublicRootUrl = getPublicRootUrl;

var getLocalizedPublicPath = function getLocalizedPublicPath(lang) {
  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return "" + getPublicRootUrl(lang) + pathname;
};

exports.getLocalizedPublicPath = getLocalizedPublicPath;

var getLocalizedPublicUrl = function getLocalizedPublicUrl(lang, pathname) {
  var _getLocation2 = getLocation(),
      _getLocation2$origin = _getLocation2.origin,
      origin = _getLocation2$origin === void 0 ? "https://ecosystem.hubspot" + ((0, _env.isQa)() ? 'qa' : '') + ".com" : _getLocation2$origin;

  return "" + origin + getLocalizedPublicPath(lang, pathname);
};

exports.getLocalizedPublicUrl = getLocalizedPublicUrl;

var getFormattedUrl = function getFormattedUrl(href) {
  if (!href) return null;

  var _parseUrl = (0, _url.parseUrl)(href),
      protocol = _parseUrl.protocol;

  return !protocol ? "http://" + href : href;
};

exports.getFormattedUrl = getFormattedUrl;

var getSuperCategoryFilterUrl = function getSuperCategoryFilterUrl(superCategory) {
  var superCategoryFacet = SuperCategorySlug[superCategory];

  if (!superCategoryFacet) {
    console.error("Unable to lookup facet for super category '" + superCategory + "'");
    return '';
  }

  return "/" + superCategoryFacet;
};

exports.getSuperCategoryFilterUrl = getSuperCategoryFilterUrl;

var getCategoryFilterUrl = function getCategoryFilterUrl(category, _superCategory) {
  var categoryFacet = CategorySlug[category];

  if (!categoryFacet) {
    console.error("Unable to lookup facet for category '" + category + "'");
    return '';
  }

  var superCategory = _superCategory || (0, _groupTags.getCategorySuperCategory)(category);

  return getSuperCategoryFilterUrl(superCategory) + "/" + categoryFacet;
};

exports.getCategoryFilterUrl = getCategoryFilterUrl;

var getListingDetailUrl = function getListingDetailUrl(slug, category) {
  return getCategoryFilterUrl(category) + "/" + slug;
};

exports.getListingDetailUrl = getListingDetailUrl;

var getCollectionUrl = function getCollectionUrl(collection) {
  var collectionFacet = StorefrontCollectionSlug[collection];

  if (!collectionFacet) {
    console.error("Unable to lookup facet for collection '" + collection + "'");
    return '';
  }

  return "/" + collectionFacet;
};

exports.getCollectionUrl = getCollectionUrl;
var PAGE_PATH_REGEX = /\/page\/\d+/;

var stripPathPagination = function stripPathPagination(pathname) {
  return pathname.replace(PAGE_PATH_REGEX, '');
};

exports.stripPathPagination = stripPathPagination;

var getPathPagination = function getPathPagination(pathname, page) {
  if (page <= 1) {
    return stripPathPagination(pathname);
  }

  var paginationPath = "/page/" + page;
  return PAGE_PATH_REGEX.test(pathname) ? pathname.replace(PAGE_PATH_REGEX, paginationPath) : "" + pathname + paginationPath;
};

exports.getPathPagination = getPathPagination;

var getHasPathPagination = function getHasPathPagination(pathname) {
  return PAGE_PATH_REGEX.test(pathname);
};

exports.getHasPathPagination = getHasPathPagination;

var getConnectedAppsUrl = function getConnectedAppsUrl(isCustomer) {
  if (!isCustomer) {
    return "https://app.hubspot" + ((0, _env.isQa)() ? 'qa' : '') + ".com/l/integrations-settings/installed";
  }

  return window.location.origin + "/integrations-settings/" + _PortalIdParser.default.get() + "/installed";
};

exports.getConnectedAppsUrl = getConnectedAppsUrl;

var getAllCollectionsUrl = function getAllCollectionsUrl() {
  return '/';
};

exports.getAllCollectionsUrl = getAllCollectionsUrl;

var getAllCategoriesUrl = function getAllCategoriesUrl() {
  return '/all-categories';
};

exports.getAllCategoriesUrl = getAllCategoriesUrl;

var getStorefrontScreenshotUrl = function getStorefrontScreenshotUrl() {
  return "https://" + ((0, _env.deployed)() ? 'static' : 'local') + ".hsappstatic.net/ecosystem-marketplace-apps-ui/ex/img/storefront-screenshot" + ((0, _env.isQa)() ? '-qa' : '') + ".png";
};

exports.getStorefrontScreenshotUrl = getStorefrontScreenshotUrl;

var getLocalizedHubSpotUrl = function getLocalizedHubSpotUrl(lang) {
  var subdomain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'www';

  switch (lang) {
    case 'de':
    case 'es':
    case 'fr':
      return "https://" + subdomain + ".hubspot." + lang;

    case 'ja':
      return "https://" + subdomain + ".hubspot.jp";

    case 'pt':
      return 'https://br.hubspot.com';

    default:
      return "https://" + subdomain + ".hubspot.com";
  }
};

exports.getLocalizedHubSpotUrl = getLocalizedHubSpotUrl;

var getSignupUrl = function getSignupUrl(lang, pathname) {
  var url = getLocalizedHubSpotUrl(lang) + "/products/get-started";

  if (pathname) {
    var referrer = (0, _history.getFullHref)(pathname, false);
    return url + "?hubs_content=" + referrer;
  }

  return url;
};

exports.getSignupUrl = getSignupUrl;

var getContactUrl = function getContactUrl(lang) {
  return getLocalizedHubSpotUrl(lang, 'offers') + "/contact-sales";
};

exports.getContactUrl = getContactUrl;

var getAllReviewsUrl = function getAllReviewsUrl(isPublic, slug, category) {
  var ROOT = isPublic ? getPublicRootUrl() : getAppRootUrl();
  return "" + ROOT + getListingDetailUrl(slug, category) + "/reviews";
};

exports.getAllReviewsUrl = getAllReviewsUrl;


//////////////////
// WEBPACK FOOTER
// ./js/utils/urls.js
// module id = 27
// module chunks = 209 210 211 212 213